//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        hideCloseButton: {
            type: Boolean,
            default: false,
        },
        persistent: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'info',
            validator: value => ['info', 'success', 'error'].includes(value),
        },
    },
    data() {
        return {
            closeButton: !!this.$listeners.close && !this.hideCloseButton,
        };
    },
};
